import React, { useState } from "react";
import styles from "./weather-description.module.css";
import FilterSelect from "../../filter-select/filter-select";
import EventDescription from "./event-description";
import { useSelector } from "react-redux";
import DeckChanger from "../../deck/deck-changer";
import { selectSelectedDeck } from "../../../store/selectors/deckSelectors";
import { selectArcanaEntities } from "../../../store/selectors/arcanaSelectors";
import { getUIText } from "../../../translation";
import { LOCALES } from "../../../constants";

const option_KOR = "아르카나 이벤트";
const option_ENG = "Arcana Event";

export default function ArcanaDescription({ lang, desc }) {
    // const decks = useSelector((state) => state.decks.value);
    const deck = useSelector((state) => selectSelectedDeck(state));
    const arcanaEntities = useSelector((state) => selectArcanaEntities(state));

    const arcanaList = deck.arcanaIds.map((id) => arcanaEntities[id]);
    const optionList = [
        { name: lang === LOCALES.KO ? option_KOR : option_ENG, value: "all" },
        ...arcanaList.map((e) => {
            return { name: e.name[lang], value: e.id };
        }),
    ];

    const [selected, setSeleted] = useState(optionList[0]);

    const obj = arcanaEntities[selected.value];

    const tag =
        selected.value !== "all" && obj ? (
            <>
                {obj.events.map((e) => (
                    <EventDescription lang={lang} selected={{ variants: [e] }} desc={desc} isArcana={true} />
                ))}
            </>
        ) : (
            <></>
        );

    return (
        <div className={styles["arcana-description"]}>
            <div className={styles["title"]}>{getUIText(lang, "schedule.modal.event.arcana.title")}</div>
            <div className={styles["deck-changer-wrapper"]}>
                <DeckChanger showEditButtons={false} />
            </div>
            <FilterSelect
                id={"arcana"}
                list={optionList}
                selected={selected}
                isUseDispatch={false}
                changeFilter={setSeleted}
                forceWidth={"280px"}
            />
            {tag}
        </div>
    );
}
